import axios from 'axios';
import AppConsts from './appConstants';
import CookieUtils from './cookieUtils';

const ajax = axios.create({
    baseURL: AppConsts.remoteServiceBaseUrl,
    timeout: 30000,
});

// Intercept API calls to add the Authorization header when needed
// and to log API calls when they are made
ajax.interceptors.request.use((config) => {
    if (CookieUtils.getToken()) {
        config.headers["Authorization"] = `Bearer ${CookieUtils.getToken()}`;
    }
    return config;
}, error => Promise.reject(error));

export default ajax;